import { Encoding } from "../core/api/models";

export class SendEncodingTypesUiDto {
    type?: Encoding;
    colorName?: string;
    color?: string;
}

const styles = getComputedStyle(document.documentElement);

export const SendEncodingTypesUi: SendEncodingTypesUiDto[] = [
    {
        type: Encoding.English,
        colorName: "danger",
        color: styles.getPropertyValue('--color-danger'),
    },
    {
        type: Encoding.Persian,
        colorName: "blue",
        color: styles.getPropertyValue('--color-blue'),
    },
];